import {
    SET_HOVERED_TABLE_CELL,
    RESET_HOVERED_TABLE_CELL,
    ADD_ACTIVE_TABLE_ROW,
    REMOVE_ACTIVE_TABLE_ROW,
    SET_SELECTED_TABLE_COLUMN_NAME,
    SET_SELECTED_TABLE_CELL,
    ADD_SELECTED_TABLE_ROW,
    REMOVE_SELECTED_TABLE_ROW,
    RESET_SELECTED_TABLE_CELLS
} from './constants';

export function setHoveredTableCell(rowId, columnName) {
    return {
        type: SET_HOVERED_TABLE_CELL,
        payload: {
            rowId,
            columnName
        }
    };
}

export function resetHoveredTableCell() {
    return {
        type: RESET_HOVERED_TABLE_CELL
    };
}

export function addActiveTableRow(rowId) {
    return {
        type: ADD_ACTIVE_TABLE_ROW,
        payload: {
            rowId
        }
    };
}

export function removeActiveTableRow(rowId) {
    return {
        type: REMOVE_ACTIVE_TABLE_ROW,
        payload: {
            rowId
        }
    };
}

export function setSelectedTableColumnName(columnName) {
    return {
        type: SET_SELECTED_TABLE_COLUMN_NAME,
        payload: {
            columnName
        }
    };
}

export function setSelectedTableCell(rowId, columnName) {
    return {
        type: SET_SELECTED_TABLE_CELL,
        payload: {
            rowId,
            columnName
        }
    };
}

export function addSelectedTableRow(rowId, columnName) {
    return {
        type: ADD_SELECTED_TABLE_ROW,
        payload: {
            rowId,
            columnName
        }
    };
}

export function removeSelectedTableRow(rowId) {
    return {
        type: REMOVE_SELECTED_TABLE_ROW,
        payload: {
            rowId
        }
    };
}

export function resetSelectedTableCells() {
    return {
        type: RESET_SELECTED_TABLE_CELLS,
        payload: {}
    };
}
